import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';

export default function Blog() {

    const blogs = [
        {
            title: "How to Build a Job-Winning Resume in 2026",
            desc: "Learn how to create an ATS-friendly resume that actually gets interviews.",
            date: "April 2026",
            author: "Genius Bridge Technologies Team",
            image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4"
        },
        {
            title: "Top 10 Interview Questions & How to Answer Them",
            desc: "Master the most asked interview questions with expert strategies.",
            date: "March 2026",
            author: "Career Experts",
            image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df"
        },
        {
            title: "Why Most Developers Fail Interviews",
            desc: "Common mistakes candidates make and how to avoid them.",
            date: "February 2026",
            author: "Hiring Managers",
            image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c"
        },
        {
            title: "Roadmap to Become a Full Stack Developer",
            desc: "Step-by-step guide to becoming a job-ready developer.",
            date: "January 2026",
            author: "Tech Mentors",
            image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
        }
    ];

    return (
        <div className="relative min-h-screen bg-brand-light pt-32 pb-20 px-6 overflow-hidden">

            {/* BACKGROUND */}
            <div className="absolute inset-0 bg-brand-radial -z-10"></div>

            <div className="max-w-7xl mx-auto">

                {/* HEADER */}
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
                        Our{" "}
                        <span className="bg-brand-gradient bg-clip-text text-transparent">
                            Blog
                        </span>
                    </h1>

                    <p className="text-slate-600 text-lg max-w-2xl mx-auto">
                        Insights, tips, and strategies to accelerate your career.
                    </p>
                </div>

                {/* BLOG GRID */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

                    {blogs.map((blog, index) => (
                        <div
                            key={index}
                            className="group bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl shadow-sm hover:shadow-xl transition-all overflow-hidden"
                        >

                            {/* IMAGE */}
                            <div className="h-48 overflow-hidden relative">
                                <img
                                    src={blog.image}
                                    alt={blog.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                />

                                {/* Overlay */}
                                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition"></div>
                            </div>

                            {/* CONTENT */}
                            <div className="p-6">

                                <h3 className="text-xl font-bold mb-3 group-hover:text-brand-primary transition">
                                    {blog.title}
                                </h3>

                                <p className="text-slate-600 text-sm mb-4">
                                    {blog.desc}
                                </p>

                                {/* META */}
                                <div className="flex items-center justify-between text-sm text-slate-500 mb-4">
                                    <div className="flex items-center gap-2">
                                        <Calendar size={14} />
                                        {blog.date}
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <User size={14} />
                                        {blog.author}
                                    </div>
                                </div>

                                {/* READ MORE */}
                                <button className="flex items-center gap-2 text-brand-primary font-semibold hover:gap-3 transition-all">
                                    Read More <ArrowRight size={16} />
                                </button>

                            </div>
                        </div>
                    ))}

                </div>

                {/* CTA */}
                <div className="mt-20 text-center">
                    <h3 className="text-2xl font-bold mb-4">
                        Want more career tips?
                    </h3>

                    <button className="bg-brand-gradient text-white px-10 py-4 rounded-xl font-bold shadow-lg hover:opacity-90 transition">
                        Subscribe to Updates
                    </button>
                </div>

            </div>
        </div>
    );
}